import {gql} from 'react-apollo';

export const LEAD_AGE_GROUPS = gql`{
  leadAgeGroups{
    groupName
    groupTitle
  }
}`;

export const LEAD_DURATION_GROUPS = gql`{
  leadDurationGroups{
    groupName
    groupTitle
  }
}`;

export const CONSUMER_ORIGIN_GROUPS = gql`{
  consumerOriginGroups{
    groupName
    groupTitle
  }
}`;

export const OS_GROUPS = gql`
query osGroups {
  osGroups {
		id
		name
	}
}
`;

export const BROWSER_GROUPS = gql`
query browserGroups {
  browserGroups {
		id
		name
	}
}
`;

export const TRAFFIC_CHANNELS = gql`
query trafficChannels {
  trafficChannels {
		id
		name
	}
}
`;


export const AFFILIATE_NETWORKS = gql`
query affiliateNetworks {
  affiliateNetworks {
		id
		nameEng
        nameRus
	}
}
`;

export const DEVICE_TYPES = gql`
query deviceTypes {
    deviceTypes {
        id
        name
    }
}
`;

export const LEAD_COUNTRIES = gql`{
    leadCountries: leadCountries  
}`;

export const CITIES = gql`
query cities($country: String!) {
    cities(country: $country) {
        country {
          name
        }
        region {
          id
          name
        }
        name
        id
    }
}
`;

export const leadGroupsQuery = (metric) => {
  switch (metric) {
    case 'lead-age':
      return LEAD_AGE_GROUPS;
    case 'lead-duration':
      return LEAD_DURATION_GROUPS;
    case 'consumer-origin':
      return CONSUMER_ORIGIN_GROUPS;
    default:
      return null
  }
};
export const leadGroupsVar = (metric) => {
    return metric.split('-').map((v, i) => {
        return (i === 0 ? v : v[0].toUpperCase() + v.substr(1));
    }).join('') + 'Groups';
};

export const LEADS_QUERY = gql`
query leads($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups:  [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String], $limit: Int = 0, $offset: Int = 0, $order: String = "") {
  leads(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region, limit: $limit, offset: $offset, order: $order) {
    total
    data {
      id
      submitTime
      submitClientTime
      sessionStarted
      osGroup
      device
      deviceName
      cityOrRegion
      countryName
      city {
        name
      }
      region {
        name
      }
      country {
        name
      }
      trafficChannel {
        name
      }
      affiliateNetwork {
        nameRus
        nameEng
      }
      deviceModel {
        model
        deviceType {
          name
        }
      }
      isFraud
      fraudAuthenticityCheckOk
      fraudAgeCheckOk
      fraudDurationCheckOk
      score
    }
  }
}
`;

export const LEADS_BY_PERIOD_QUERY = gql`
query leadsByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadsByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    created
    leadsCount
  }
}
`;

export const LEAD_DURATION_BY_PERIOD_QUERY = gql`
query leadDurationByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $groups: [String], $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadDurationByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, groups: $groups, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    created
		groupName
    groupTitle
    groupOrder
    leadsCount
  }
}
`;

export const LEAD_AGE_BY_PERIOD_QUERY = gql`
query leadAgeByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $groups: [String], $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadAgeByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, groups: $groups, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    created
		groupName
    groupTitle
    groupOrder
    leadsCount
  }
}
`;

export const CONSUMER_ORIGIN_BY_PERIOD_QUERY = gql`
query consumerOriginByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $groups: [String], $projects: [UUID], $bySubnet: Boolean, $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: consumerOriginByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, groups: $groups, projects: $projects, bySubnet: $bySubnet, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    created
    groupName
    groupTitle
    groupOrder
    leadsCount
	}
}
`;


export const LEAD_INFO_BY_ID=gql`
    query lead($id: String!) {
        lead(leadId: $id) {
            id
            score
            feedbackResult
            feedbackTime
            sessionStarted
            affiliateNetwork {
              nameRus
            }
            affiliateNetwork {
              nameRus
              nameEng
            }
            geoInfo
            geo {
              city {
                id
                name
              }
              region {
                id
                name
              }
              country {
                id
                name
                country
              }
            }
            browser {
              version 
                family {
                  name
              }
            }
            deviceModel {
              model
              deviceType {
                name
              }
              brand {
                name
              }
            }
            submitTime
            sessionStarted
            pixel {
              id 
              title
              project {
                title
              }
            }
            osVersion {
              name
              family {
                group {
                  name
                }
                name
              }
            }
            provider {
              asn
              asnDescription
            }
            ipAddr
            trafficChannel {
              name
            }
            screen {
              width
              height
            }
            referrer
            location
            metrikLeadAge
            metrikLeadDuration
            duplication
            frequency
            ipFrequency
            totalEntities
            totalHops
            customerFrequency
            isAuthentic
        }
    }
`

export const LEAD_LINEAGE_BY_PERIOD_QUERY = gql`
query leadLineageByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String], $leadOwner: String) {
  data: leadLineageByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region, leadOwner: $leadOwner) {
    created
    groupName
    groupTitle
    groupOrder
    leadsCount
	}
}
`;

export const LEAD_AGE_TOTALS_QUERY = gql`
query leadAgeTotals($dateFrom: DateTime!, $dateTo: DateTime!, $groups: [String], $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadAgeTotals(dateFrom: $dateFrom, dateTo: $dateTo, groups: $groups, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    groupName
    groupTitle
    groupOrder
    leadsCount
  }
}
`;

export const LEAD_DURATION_TOTALS_QUERY = gql`
query leadDurationTotals($dateFrom: DateTime!, $dateTo: DateTime!, $groups: [String], $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadDurationTotals(dateFrom: $dateFrom, dateTo: $dateTo, groups: $groups, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    groupName
    groupTitle
    groupOrder
    leadsCount
  }
}
`;

export const LEAD_BROWSER_TOTALS_QUERY = gql`
query leadBrowserTotals($dateFrom: DateTime!, $dateTo: DateTime!, $isMobile: Boolean!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadBrowserTotals(dateFrom: $dateFrom, dateTo: $dateTo, isMobile: $isMobile, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    groupName
    groupTitle
    groupOrder
    leadsCount
  }
}
`;

export const LEAD_BROWSER_BY_PERIOD = gql`
query leadBrowserByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String], $isMobile: Boolean!) {
  data: leadBrowserByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region, isMobile: $isMobile) {
    created
    groupName
    groupTitle
    groupOrder
    leadsCount
    __typename
  }
}
`;

export const LEAD_CLOSURE_BY_PERIOD = gql`
query leadClosureByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String], $scoringTypes: [String]) {
  data: leadClosureByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region, scoringTypes: $scoringTypes) {
    created
    groupName
    groupTitle
    groupOrder
    leadsCount
    __typename
  }
}
`;

export const LEAD_RELATIVE_CLOSURE_BY_PERIOD = gql`
query leadRelativeClosureByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String], $scoringTypes: [String]) {
  data: leadRelativeClosureByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region, scoringTypes: $scoringTypes) {
    created
    groupName
    groupTitle
    groupOrder
    leadsCount
    totalLeadsCount
    leadsRelative
    __typename
    
  }
}
`;


export const LEAD_OS_BY_PERIOD = gql`
query leadOsByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $isMobile: Boolean!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadOsByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, isMobile: $isMobile, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    created
    groupName
    groupTitle
    groupOrder
    leadsCount
    __typename
  }
}
`;

export const LEAD_DEVICE_TYPE_BY_PERIOD = gql`
query leadDeviceTypeByPeriod($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadDeviceTypeByPeriod(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    created
    groupName
    groupTitle
    groupOrder
    leadsCount
    __typename
  }
}
`;

export const LEAD_DEVICE_TYPE_TOTALS_QUERY = gql`
query leadDeviceTypeTotals($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadDeviceTypeTotals(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    groupName
    groupTitle
    groupOrder
    leadsCount
  }
}
`;

export const LEAD_OS_TOTALS_QUERY = gql`
query leadOsTotals($dateFrom: DateTime!, $dateTo: DateTime!, $isMobile: Boolean!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadOsTotals(dateFrom: $dateFrom, dateTo: $dateTo, isMobile: $isMobile, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    groupName
    groupTitle
    groupOrder
    leadsCount
  }
}
`;

export const LEAD_AFFILIATE_NETWORK_TOTALS_QUERY = gql`
query leadAffiliateNetworkTotals($dateFrom: DateTime!, $dateTo: DateTime!, $isMobile: Boolean!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadAffiliateNetworkTotals(dateFrom: $dateFrom, dateTo: $dateTo, isMobile: $isMobile, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    groupName
    groupTitle
    groupOrder
    leadsCount
  }
}
`;


export const URL_LABEL_LIST = gql`
query urlLabelList($labelType: String!, $labelName: String!, $search: String = "") {
  data: urlLabelList(labelType: $labelType, labelName: $labelName, search: $search)
}
`;

export const PAGE_FILTERS = gql`
query pageFilters($page: String!) {
  pageFilters(page: $page)
}
`;

export const TOTAL_VISITS = gql`
query totalVisits($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  totalVisits(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) 
}
`;

export const TOTAL_CONVERSIONS = gql`
query totalConversions($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  totalConversions(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) 
}
`;

export const TOTAL_DEVICES = gql`
query totalDevices($dateFrom: DateTime!, $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  totalDevices(dateFrom: $dateFrom, dateTo: $dateTo, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) 
}
`;

export const LEAD_SCORING_BY_PERIOD = gql`
query leadScoringByPeriod($scoringTypes: [String], $dateFrom: DateTime!, $dateTo: DateTime!, $groups: [String], $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadScoringByPeriod(scoringTypes: $scoringTypes, dateFrom: $dateFrom, dateTo: $dateTo, groups: $groups, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    created
    groupName
    groupTitle
    groupOrder
    leadsCount
    __typename
  }
}
`;

export const LEAD_SCORING_TOTAL = gql`
query leadScoringTotals($scoringTypes: [String], $dateFrom: DateTime!, $dateTo: DateTime!, $groups: [String], $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadScoringTotals(scoringTypes: $scoringTypes, dateFrom: $dateFrom, dateTo: $dateTo, groups: $groups, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    groupName
    groupTitle
    groupOrder
    leadsCount
    __typename
  }
}
`;
export const LEAD_CUSTOMER_JOURNEY = gql`
query leadCustomerJourney($id: String!) {
  data: leadCustomerJourney(leadId: $id) {
    total
    data {
      isNameMatched
      isPhoneMatched
      isEmailMatched
      submitTime
      buyer
      deviceMatched
      ipMatched
      product
      url
      thisLead
      leadId
      referrer
      deviceType
      affiliateNetwork { 
        nameRus nameEng 
      }
    }
  }
}`

export const LEADS_GFM = gql`
query leadsGfmStat($dateFrom: DateTime!, $scalePeriod: String, $intervals: [Int], $dateTo: DateTime!, $projects: [UUID], $labelType: String, $labelValues: JSONDict, $osGroups: [Int], $browserGroups: [Int], $trafficChannels: [Int], $affiliateNetworks: [Int], $deviceTypes: [Int], $country: String, $cities: [String], $region: [String]) {
  data: leadsGfmStat(dateFrom: $dateFrom, dateTo: $dateTo, scalePeriod: $scalePeriod, intervals: $intervals, projects: $projects, labelType: $labelType, labelValues: $labelValues, osGroups: $osGroups, browserGroups: $browserGroups, trafficChannels: $trafficChannels, affiliateNetworks: $affiliateNetworks, deviceTypes: $deviceTypes, country: $country, cities: $cities, region: $region) {
    created
    groupTitle
    percent
    leadsCount
    leadsSuccessCount
    conversion
  }
}`



// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/gql/query.js